import { cn } from '@forest/shared'

/** Inline copy of assets/figma/hourglass.svg with a `currentColor` fill so
 *  the countdown pill can flip it red alongside the text once the event
 *  ends (an `<img>` of the asset can't be recolored). */
export function HourglassIcon(props: { class?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="none"
      aria-hidden="true"
      class={cn('shrink-0', props.class)}
    >
      <path
        d="M15.7137 16.814H15.4708V16.2712C15.4708 13.8997 14.0137 11.6283 11.428 9.94258C11.9708 9.58544 12.4565 9.21401 12.8994 8.81401C14.5851 7.28544 15.4708 5.48544 15.4708 3.61401V3.18544H15.7137C16.1422 3.18544 16.4851 2.84258 16.4851 2.41401C16.4851 1.98544 16.1422 1.64258 15.7137 1.64258H4.2851C3.85653 1.64258 3.51367 1.98544 3.51367 2.41401C3.51367 2.84258 3.85653 3.18544 4.2851 3.18544H4.4851V3.61401C4.4851 5.98544 5.94224 8.25686 8.52796 9.94258C7.9851 10.2997 7.49939 10.6711 7.05653 11.0711C5.37081 12.5997 4.4851 14.3997 4.4851 16.2712V16.814H4.2851C3.85653 16.814 3.51367 17.1569 3.51367 17.5854C3.51367 18.014 3.85653 18.3569 4.2851 18.3569H15.7137C16.1422 18.3569 16.4851 18.014 16.4851 17.5854C16.4851 17.1569 16.1422 16.814 15.7137 16.814ZM6.14224 3.61401V3.18544H13.8137V3.61401C13.8137 5.08544 13.0994 6.51401 11.728 7.75686C11.228 8.22829 10.6422 8.64258 9.97081 9.02829C7.52796 7.59972 6.12796 5.64258 6.14224 3.61401ZM6.01367 16.4569C6.01367 14.9426 6.75653 13.4711 8.17081 12.1854C8.42796 11.9426 8.71367 11.714 9.01367 11.4854C9.01367 11.4854 9.01367 11.4854 9.02796 11.4854C9.32796 11.2711 9.62796 11.0711 9.95653 10.8854C11.2137 11.6283 12.1994 12.4997 12.8851 13.4426C13.5565 14.3997 13.9137 15.414 13.9137 16.4712V16.8426H5.99939V16.4712L6.01367 16.4569Z"
        fill="currentColor"
      />
    </svg>
  )
}
